export enum StudentDataType
{
    Assignment = 1,
    Quiz = 2,
    Exam = 3,
    CourseGrade = 4,
    Event = 5,
    Lesson = 6
}